module.exports = __webpack_public_path__ + "img/homeflow.e9bb9d00.png";